import i18next from 'i18next'
import * as React from 'react'
import { capitalize } from 'utils/utils'
import { SubscriptionPrice } from './subscriptionPriceSelectorState'
import { formatSubscriptionPrice } from 'subscription/subscriptionUtils'

type SubscriptionPriceOptionProps = {
    kind: 'account-details' | 'trial-to-pro'
    select: (s: SubscriptionPrice) => void
    availableSubscriptions: Array<SubscriptionPrice>
    currentSubscription?: SubscriptionPrice
}

export const SubscriptionPriceOption = (props: SubscriptionPriceOptionProps) => {
    const saveMoneyTranslation = (currency: string) =>
      i18next
        .t('subscription:SaveMoney', { amount: `${currency} 19!` })
        .toLowerCase()

    const cancelAnytimeTranslation = () =>
      i18next.t('subscription:CancelAnytime').toLowerCase()

    const PaymentSubTitleTranslation = (
      paymentFrequency: 'monthly' | 'yearly' | undefined,
      currency: string | undefined
    ): string => {
      switch (paymentFrequency) {
        case 'yearly':
          return ` (${saveMoneyTranslation(currency || '€')})`
        case 'monthly':
          return ` (${cancelAnytimeTranslation()})`
        case undefined:
          return ''
      }
    }

    return (
      <fieldset className="account__bools styled-bools sb sb--ghost sb--radio">
        <legend className={props.kind === 'trial-to-pro' ? 'title--s' : ''}>
          {props.kind === 'trial-to-pro' &&
            `${i18next.t('subscription:ChooseYourSubscription')}:`}
          {props.kind === 'account-details' &&
            `${i18next.t('subscription:SelectYourPreferredPaymentPeriod')}:`}
        </legend>

        {props.availableSubscriptions.map((s, index) => {
          const id = `sb-${index}`

          return (
            <div className="sb__bool" key={s.PaymentFrequency}>
              <input
                type="radio"
                name="sb-subscription"
                className="sb__input form-check-input"
                checked={
                  s.Id == props.currentSubscription?.Id &&
                  s.Id != undefined
                }
                disabled={
                  s.Id == props.currentSubscription?.Id &&
                  s.Id != undefined
                }
                onChange={(e) => props.select(s)}
                id={id}
              />
              <label
                className="sb__label"
                htmlFor={id}
              >
                <span
                  className={`sb__title ${
                    props.kind === 'trial-to-pro' ? 'title--xs' : ''
                  }`}
                >
                  {capitalize(
                    i18next.t(`subscription:${s.PaymentFrequency?.toLowerCase()}`)
                  )}
                </span>
                <span className="sb__subtitle">
                  {`${s.Currency} ${
                    s.PaymentFrequency?.toLowerCase().includes('month')
                      ? formatSubscriptionPrice(s.Price || 0, i18next.language)
                      : s.Price
                  } /${i18next.t(
                    `subscription:${
                      s.PaymentFrequency?.toLowerCase().includes('month')
                        ? 'month'
                        : 'year'
                    }`
                  )}${PaymentSubTitleTranslation(
                    s.PaymentFrequency !== undefined
                      ? s.PaymentFrequency.toLowerCase().includes('month')
                        ? 'monthly'
                        : s.PaymentFrequency.toLowerCase().includes('year')
                        ? 'yearly'
                        : undefined
                      : undefined,
                    s.Currency
                  )}`}
                </span>
              </label>
            </div>
          )
        })
      }
      </fieldset>
    )
}